/**
 * Warehouse gun dormancy. After 30 minutes with no scans or taps the
 * gun signs out to the PIN pad (never the email login).
 */

import { DEFAULT_STAFF_IDLE_LOCK_MINUTES } from "./staffIdleLock";
import {
  isFullAppSearch,
  isHandheldSearch,
  isHandheldTaskPath,
  isWarehouseScannerDevice,
} from "./handheldMode";

export const HANDHELD_IDLE_LOGOUT_MS = DEFAULT_STAFF_IDLE_LOCK_MINUTES * 60 * 1000;
export const HANDHELD_IDLE_LOGOUT_KEY = "riverr_handheld_idle_logout_v1";

export function shouldHandheldIdleLogout(user) {
  return Boolean(user?.uid);
}

export function isScannerIdleSession({
  pathname = "",
  search = "",
  userAgent = "",
  screenWidth,
  screenHeight,
  innerWidth,
  innerHeight,
  devicePixelRatio = 1,
} = {}) {
  if (isFullAppSearch(search)) return false;
  if (isHandheldTaskPath(pathname) || isHandheldSearch(search)) return true;
  return isWarehouseScannerDevice({
    userAgent,
    screenWidth,
    screenHeight,
    innerWidth,
    innerHeight,
    devicePixelRatio,
  });
}

export function handheldIdleDue(
  lastActivityAt,
  now,
  timeoutMs = HANDHELD_IDLE_LOGOUT_MS
) {
  const last = Number(lastActivityAt);
  if (!Number.isFinite(last)) return false;
  return now - last >= timeoutMs;
}

export function readHandheldIdle(uid) {
  if (!uid || typeof sessionStorage === "undefined") return null;
  try {
    const parsed = JSON.parse(sessionStorage.getItem(HANDHELD_IDLE_LOGOUT_KEY) || "null");
    if (!parsed || parsed.uid !== uid) return null;
    const lastActivityAt = Number(parsed.lastActivityAt);
    if (!Number.isFinite(lastActivityAt)) return null;
    return { uid, lastActivityAt };
  } catch {
    return null;
  }
}

export function noteHandheldActivity(uid, at = Date.now()) {
  if (!uid || typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(
      HANDHELD_IDLE_LOGOUT_KEY,
      JSON.stringify({ uid, lastActivityAt: at })
    );
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearHandheldIdleLogout() {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.removeItem(HANDHELD_IDLE_LOGOUT_KEY);
  } catch {
    /* ignore */
  }
}
